import Vue from 'vue';
const currency = (value) => {
    const priceAmount = parseInt(value.toString());
    if (priceAmount === 0) {
        return "$0.00";
    } else {
        return "$" + (priceAmount / 100).toFixed(2).toString();
    }
}
Vue.filter('currency', currency);